import PopupPagination from "../../../component/Pagination/popupPagination";
import { SellerPubMissionMemberStatsItemResponse } from "../../../api/pub-mission-member";
import * as S from "../styles";

interface MemberListPanelProps {
  members: SellerPubMissionMemberStatsItemResponse[];
  selectedMemberId?: number;
  search: string;
  onSearchChange: (value: string) => void;
  onSearch: () => void;
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onSelect: (member: SellerPubMissionMemberStatsItemResponse) => void;
}

const MemberListPanel = ({
  members,
  selectedMemberId,
  search,
  onSearchChange,
  onSearch,
  currentPage,
  totalPages,
  onPageChange,
  onSelect,
}: MemberListPanelProps) => {
  return (
    <S.ListPanel>
      <S.PanelHeader>유저 목록</S.PanelHeader>
      <S.ListPanelBody>
        <S.SearchRow>
          <S.SearchInput
            placeholder="닉네임 검색"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyUp={(e) => e.key === "Enter" && onSearch()}
          />
          <S.PurpleButton type="button" onClick={onSearch}>
            검색
          </S.PurpleButton>
        </S.SearchRow>

        <S.MemberTableHeader>
          <span className="user">유저</span>
          <span>미션</span>
          <span>빙고</span>
          <span className="unclaimed">미수령</span>
          <span>최근 처리</span>
        </S.MemberTableHeader>

        <S.MemberTableBody>
          {members.length === 0 ? (
            <S.EmptyMessage>회원이 없습니다.</S.EmptyMessage>
          ) : (
            members.map((member) => (
              <S.MemberRow
                key={member.memberId}
                type="button"
                $selected={selectedMemberId === member.memberId}
                onClick={() => onSelect(member)}
              >
                <div className="user">
                  <span className="nickname">{member.nickname}</span>
                </div>
                <span className="stat">{member.missionCompleteCount}</span>
                <span className="stat">{member.bingoCompleteCount}</span>
                <span className="stat unclaimed">{member.unclaimedCount}</span>
                <span className="stat recent">
                  {member.latestProcessedAt ?? "-"}
                </span>
              </S.MemberRow>
            ))
          )}
        </S.MemberTableBody>

        {totalPages > 1 && (
          <S.PaginationBox>
            <PopupPagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </S.PaginationBox>
        )}
      </S.ListPanelBody>
    </S.ListPanel>
  );
};

export default MemberListPanel;
